import axiosInstance from '../api/axiosConfig';
import { getApiBaseUrl } from '../baseUrl';
import { Vaga } from '../../types/vaga/vaga';
import { obterIdEmpresa } from '../../utils/empresa';

export const buscarVagasEmpresa = async (): Promise<Vaga[]> => {
  const apiUrl = getApiBaseUrl();
  
  try {
    const empresaId = obterIdEmpresa();
    
    
    if (!empresaId) {
      console.error('ID da empresa não encontrado');
      return [];
    }

    const url = `${apiUrl}/vagas/empresa/${empresaId}`;
    
    const response = await axiosInstance.get(url);
    
    const data = Array.isArray(response.data) 
      ? response.data 
      : (response.data?.data || []);
      
    return data;
  } catch (error) {
    console.error('Erro ao buscar vagas da empresa:', error);
    return [];
  }
};

export const excluirVaga = async (vagaId: number): Promise<{ sucesso: boolean; mensagem?: string }> => {
  const apiUrl = getApiBaseUrl();
  
  try {
    await axiosInstance.delete(`${apiUrl}/vagas/${vagaId}`);
    return { sucesso: true };
  } catch (error: any) {
    console.error('Erro ao excluir vaga:', error);
    
    // Capturar mensagem de erro do backend
    const mensagemErro = error.response?.data?.message || 
                        error.response?.data?.error || 
                        'Erro ao excluir vaga';
    
    return { sucesso: false, mensagem: mensagemErro };
  }
};

export const alterarStatusVaga = async (vagaId: number, ativo: boolean): Promise<boolean> => {
  const apiUrl = getApiBaseUrl();
  
  try {
    // Primeiro buscar a vaga completa
    const empresaId = obterIdEmpresa();
    if (!empresaId) {
      console.error('ID da empresa não encontrado');
      return false;
    }

    const vagasResponse = await axiosInstance.get(`${apiUrl}/vagas/empresa/${empresaId}`);
    const vagas = Array.isArray(vagasResponse.data) ? vagasResponse.data : (vagasResponse.data?.data || []);
    const vagaCompleta = vagas.find((v: any) => v.id === vagaId);
    
    if (!vagaCompleta) {
      console.error('Vaga não encontrada:', vagaId);
      return false;
    }

    // Enviar a vaga completa com apenas o status alterado
    const dadosCompletos = {
      ...vagaCompleta,
      ativo
    };
    
    
    const response = await axiosInstance.put(`${apiUrl}/vagas/${vagaId}`, dadosCompletos, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    return true;
  } catch (error: any) {
    console.error('Erro ao alterar status da vaga:', error);
    return false;
  }
};

export const atualizarVaga = async (vagaId: number, dadosVaga: Partial<Vaga>): Promise<boolean> => {
  const apiUrl = getApiBaseUrl();
  
  try {
    const url = `${apiUrl}/vagas/${vagaId}`;
    
    const response = await axiosInstance.put(url, dadosVaga, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return true;
  } catch (error: any) {
    console.error('Erro ao atualizar vaga:', error);
    return false;
  }
};

export const finalizarVaga = async (vagaId: number): Promise<boolean> => {
  const apiUrl = getApiBaseUrl();
  
  try {
    // Primeiro buscar a vaga completa
    const empresaId = obterIdEmpresa();
    if (!empresaId) {
      console.error('ID da empresa não encontrado');
      return false;
    }

    const vagasResponse = await axiosInstance.get(`${apiUrl}/vagas/empresa/${empresaId}`);
    const vagas = Array.isArray(vagasResponse.data) ? vagasResponse.data : (vagasResponse.data?.data || []);
    const vagaCompleta = vagas.find((v: any) => v.id === vagaId);
    
    if (!vagaCompleta) {
      console.error('Vaga não encontrada:', vagaId);
      return false;
    }

    // Enviar a vaga completa com ativo=false e finalizada=true
    const dadosCompletos = {
      ...vagaCompleta,
      ativo: false,
      finalizada: true
    };
    
    
    await axiosInstance.put(`${apiUrl}/vagas/${vagaId}`, dadosCompletos, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    return true;
  } catch (error: any) {
    console.error('Erro ao finalizar vaga:', error);
    return false;
  }
};